import { Button, Typography } from '@breetometer/components';
import { Animation } from 'BreetComponents';
import { closeModal, selectModals, useAppDispatch, useAppSelector } from 'BreetRedux';
import { useCallback } from 'react';

import alert from '@/assets/lottie/alert.json';

import { AlertActions, type AlertActionType, type IDialogAlert } from './DialogAlert.helpers';

const DialogAlert = ({ title, description }: IDialogAlert) => {
	const modals = useAppSelector(selectModals);

	const dispatch = useAppDispatch();

	const modal = modals.find((i) => i.id === 'alert');

	const modalMetadata = modal?.metadata as
		| { title: string; description: string; action?: { title: string; actionType: 'support'; preMessage?: string } }
		| undefined;

	const action = AlertActions[modalMetadata?.action?.actionType as unknown as AlertActionType];

	const handleAction = useCallback(() => {
		action(modalMetadata?.action?.preMessage);

		dispatch(closeModal('alert'));
	}, [action, dispatch, modalMetadata?.action?.preMessage]);

	return (
		<div className='dialog-alert bg-primary-500'>
			<Animation
				animationData={alert}
				height={150}
				width={150}
			/>

			<Typography
				as='h1'
				className='color-neutral-50'
			>
				{title ?? modalMetadata?.title}
			</Typography>
			<Typography className='color-primary-100'>{description ?? modalMetadata?.description}</Typography>

			{modalMetadata?.action && (
				<Button
					onClick={handleAction}
					variant='tertiary'
				>
					{modalMetadata.action.title}
				</Button>
			)}
		</div>
	);
};

export default DialogAlert;
